import { Component } from '@angular/core';
import SwiperCore, { SwiperOptions, Navigation, Pagination, Scrollbar, A11y } from 'swiper';
import { SharedService } from '../service/shared.service';

SwiperCore.use([Navigation, Pagination, Scrollbar, A11y]);


@Component({
  selector: 'app-example-swiper',
  templateUrl: './example-swiper.component.html',
  styleUrls: ['./example-swiper.component.css']
})
export class ExampleSwiperComponent  {
 
  constructor(public shared: SharedService) {
    this.shared.isWhiteMenu = false;
  }
  public swiperOp: SwiperOptions = {
    direction: 'horizontal',
    navigation: true,
    hashNavigation: true,
    observer: true,
    observeParents: true,
    parallax:true,
  };

  onSlideChange() {
    console.log('slide change');
  }
}
